import React, {useEffect} from "react";
import {StartActivity, sleep} from "../../../../common/common";
import * as omnimap from "../../../../../api/omnimap/omnimapActions";
import * as CallBackFunctions from "../functions/callBackFunctions";
import $ from "jquery";
import {GetSelected} from "../../../../common/tableHandler/manipulateTable";
import {MAN_PL_CONST} from "../../../../../constants/ActionEnums/ManActionEnums";
import {InitiateProcessAction} from "../../../../../api/omnimap/omnimapActions";
import DatePicker from "react-datepicker";
import 'react-datepicker/dist/react-datepicker.min.css'

class PlaatsInDetailPlanning extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            begin: "",
            end: "",
            dateCheckErrText: "Detailplanning moet binnen het bereik van globale planning vallen.",
            isFaultyBeginDay: 0,
            isFaultyEndDay: 0,
            globalBeginDay: "",
            globalEndDay: "",
            isEssentialFieldsDone: false,
        };
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    getBeginAndEnd() {
        const selected = GetSelected()
        const founded = window.$mm_schedule_Glist.filter(o1 => selected.some(o2 => o1.identification === o2));
        let nearestBegin
        let nearestEnd

        for (const item of founded) {
            if (!nearestBegin || item.globalPlanning[0] < nearestBegin) {
                nearestBegin = item.globalPlanning[0]
            }
            if (!nearestEnd || item.globalPlanning[1] < nearestEnd) {
                nearestEnd = item.globalPlanning[1]
            }
        }

        nearestBegin = nearestBegin.split('T')[0]
        nearestEnd = nearestEnd.split('T')[0]

        this.setState({
            globalBeginDay: "\n" + nearestBegin,
            globalEndDay: "\n" + nearestEnd,
        })

        return {"begin": nearestBegin, "end": nearestEnd}
    }

    isInBetweenGlobalPlanning(value) {

        let nearestBegin;
        let nearestEnd;

        const res = this.getBeginAndEnd()

        nearestBegin = res.begin
        nearestEnd = res.end
        return !(value > nearestEnd || value < nearestBegin);

    }

     handleInputChange = async (event, _name) => {
        /*const target = event.target;
        const value = target.type === "checkbox" ? target.checked : target.value;
        const name = target.name;*/
        let target;
        let value;
        let name;
        if(typeof _name !== "string"){
          target = event.target;
          value = target.type === "checkbox" ? target.checked : target.value;
          name = target.name;
        } else {
          name = _name;
          value = event;
        }

        switch (name) {
            case "begin":
                if (!this.isInBetweenGlobalPlanning(value.toISOString())) {
                    await this.setState({
                        isFaultyBeginDay: true,
                    })
                } else {
                    await this.setState({
                        isFaultyBeginDay: false,
                    })
                }
                break;
            case "end":
                if (!this.isInBetweenGlobalPlanning(value.toISOString())) {
                    await this.setState({
                        isFaultyEndDay: true,
                    })
                } else {
                    await this.setState({
                        isFaultyEndDay: false,
                    })
                }
                break;
        }
        if (
            this.state.isFaultyEndDay === false &&
            this.state.isFaultyBeginDay === false
        ) {
            await this.setState({
                'isEssentialFieldsDone': true,
            });
        }


        await this.setState({
            [name]: value,
        });
    };

    handleSubmit = () => {
        $("#cover-spin").show(0);

        const element = $("input[name=wijzig-status]:checked");
        const status = element[0].defaultValue;
        const executorId = $("input[name=uitvoerder]:checked").attr("id");

        // var model = {
        //     status: status,
        //     uitvoerder: uitvoerderId,
        //     periode: [
        //         this.state.begin + "T00:00:00.000Z",
        //         this.state.end + "T00:00:00.000Z",
        //     ],
        // };

        // const selectedIds = GetSelected();

        // StartActivity(
        //     model,
        //     selectedIds,
        //     "17a25835-e4f8-4189-bcaa-30b7194c7c2b",
        //     this.plaatsInUitvoering,
        //     window.$mm_management_units_token
        // );


        const model = {
            "action": MAN_PL_CONST.PLACE_IN_DETAIL_PLANNING,
            "werkregel_status": status,
            "period": [
                this.state.begin.toISOString(),
                this.state.end.toISOString(),
            ],
            "uitvoerder_identification": executorId,
            "identifications": GetSelected()
        }


        InitiateProcessAction(model, MAN_PL_CONST.END_POINT).then(()=>{

            $("#plaats_in_detailplanning").modal("hide");
            window.$mm_schedule_tableReload();
            this.setState({
                begin: "",
                end: "",
                dateCheckErrText: "Detailplanning moet binnen het bereik van globale planning vallen.",
                isFaultyBeginDay: 0,
                isFaultyEndDay: 0,
                globalBeginDay: "",
                globalEndDay: "",
                isEssentialFieldsDone: false,
            })

        }).catch(()=>{
            alert('Something went wrong!')
            $("#cover-spin").hide(0);
        })
    };

    formatDate(date){
        const _data = date.split('-')
        return '' + _data[2] + '/' + _data[1] + '/' + _data[0]
    }
    getDateStr() {
        return '' +
            this.formatDate(this.state.globalBeginDay) +
            " & " +
            this.formatDate(this.state.globalEndDay)
    }

    componentDidMount() {
        const _this = this
        $("#plaats_in_detailplanning").on("show.bs.modal", async function (event) {
            var selectedIds = [];

            $("#example")
                .dataTable()
                .$("tr.selected")
                .each(function () {
                    selectedIds.push($(this).attr("rowId"));
                });
            let result = await omnimap.GetActivityDefinitionAction(
                selectedIds[0],
                "3a98846b-67c1-4192-9edc-b980f10898b8",
                window.$mm_management_units_token
            );

            CallBackFunctions.WijzigStatusCallback(result, "status-grp");

            let model = {
                content: [
                    {
                        key: "algemeen-actief",
                        and_or: "AND",
                        values: [true],
                        datatype: "BOOLEAN",
                    },
                    {
                        key: "algemeen-isuitvoerder",
                        and_or: "AND",
                        values: [true],
                        datatype: "BOOLEAN"
                    }
                ],
                definitions: [process.env.REACT_APP_WORK_RESOURCE_UITVOERDER],
            };
            let uitvoerderResult = await omnimap
                .FillTableAction(model, 1, window.$mm_management_units_token)
                .catch((err) => {
                    alert(err);
                });
            CallBackFunctions.PlaatsDetailplanningCallback(uitvoerderResult, 1);


            const res = _this.getBeginAndEnd()
            _this.setState({
                globalBeginDay: res.begin,
                globalEndDay: res.end
            })
        });
    }

    render() {
        return (
            <div
                className="modal fade"
                tabIndex={-1}
                role="dialog"
                id="plaats_in_detailplanning"
            >
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Plaats in Detailplanning</h5>
                            <button
                                type="button"
                                className="close"
                                data-dismiss="modal"
                                aria-label="Close"
                            />
                        </div>
                        <div className="modal-body">
                            <div class="beheeractiviteit-zoeken-content">
                                <p>Status</p>

                                <input
                                    id="beheeractiviteit-zoeken-input"
                                    type="search"
                                    className="modal-search"
                                    placeholder="Zoeken"
                                    autoComplete="off"
                                />
                            </div>

                            <div className="modal-scroll">
                                <div id="status-grp" className="radio-grp"/>
                            </div>

                            <div class="btn-plannig-context">
                                <h2>Periode:</h2>

                                <p>Begin</p>
                                <div>
                                    <p className={this.state.isFaultyBeginDay && "red-text"}>{this.state.dateCheckErrText}</p>
                                    <p className={this.state.isFaultyBeginDay && "red-text"}>{this.getDateStr()}</p>
                                </div>
                                {/*<input
                                    id="beheereenheid_begin"
                                    type="date"
                                    className="form-control"
                                    placeholder="Horizon Begin"
                                    name="begin"
                                    value={this.state.begin}
                                    onChange={this.handleInputChange}
                                /> */}
                                <DatePicker
                                    selected={this.state.begin}
                                    onChange={(date: Date, e) => {
                                    this.setState({begin: date})
                                    this.handleInputChange(date, "begin")
                                    }}
                                    dateFormat='dd/MM/yyyy'
                                    id="beheereenheid_begin"
                                    className="form-control"
                                    placeholderText="Horizon Begin"
                                />

                                <p>Einde</p>

                                <div>
                                    <p className={this.state.isFaultyEndDay && "red-text"}>{this.state.dateCheckErrText}</p>
                                    <p className={this.state.isFaultyEndDay && "red-text"}>{this.getDateStr()}</p>
                                </div>
                                {/*<input
                                    id="beheereenheid_end"
                                    type="date"
                                    className="form-control"
                                    placeholder="Horizon Einde"
                                    name="end"
                                    value={this.state.end}
                                    onChange={this.handleInputChange}
                                />*/}
                                <DatePicker
                                    selected={this.state.end}
                                    onChange={(date: Date, e) => {
                                    this.setState({end: date})
                                    this.handleInputChange(date, "end")
                                    }}
                                    dateFormat='dd/MM/yyyy'
                                    id="beheereenheid_end"
                                    className="form-control"
                                    placeholderText="Horizon Einde"
                                />
                                <br/>
                                <h1>Uitvoerder:</h1>
                                <p>Geselecteerd: Niets geselecteerd </p>
                                <input
                                    id="planningsperiode"
                                    type="search"
                                    className="modal-search"
                                    placeholder="Zoeken"
                                />
                                <div className="modal-scroll">
                                    <div id="uitvoerder-grp" className="radio-grp"/>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button
                                type="button"
                                className="btn-modal"
                                onClick={this.handleSubmit}
                                disabled={!this.state.isEssentialFieldsDone}
                            >
                                Verwerken
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default PlaatsInDetailPlanning;